module.exports = __webpack_public_path__ + "img/4.3f2c1288.jpg";